import { type FieldStat } from '@solink/vd-data-layer/api-clients/platform/platform';

export interface UpdateFieldStatsAction {
  type: 'UPDATE_FIELD_STATS';
  fieldStats: FieldStat[];
}

export function updateFieldStats(fieldStats: FieldStat[]): UpdateFieldStatsAction {
  return { type: 'UPDATE_FIELD_STATS', fieldStats };
}

export interface UpdateHistogramCustomFieldsAction {
  type: 'UPDATE_HISTOGRAM_CUSTOM_FIELDS';
  fields: string[];
}

export function updateHistogramCustomFields(fields: string[]): UpdateHistogramCustomFieldsAction {
  return {
    type: 'UPDATE_HISTOGRAM_CUSTOM_FIELDS',
    fields,
  };
}

// Union type of all actions from `generalActions`.
export type FieldStatsAction = UpdateFieldStatsAction | UpdateHistogramCustomFieldsAction;
